import React from "react";
import '../App.css';
import './View.css';
import NavigationBar from '../components/nav';

import {Form,Container,Tabs,Tab,TabContainer,Row,Col,Button,Spinner,Table} from 'react-bootstrap';




class  ViewPatient extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            indicators: []

        }
    }


    render() {
        const indicators =['PSP','MSA','Parkinson Scale','PSP-RS','Hoen&Yarh Stage ','MoCA','FAB','Clap Test','Starkstein Apathy Scale ','Geriatric Depression Scale','Dementia Apraxia Test','Schwab and England ','SCOPA-AUT ']

        return (
          // <div className="container">
          //     <div className="FNLabel">FirstName: </div>
          //     <div className="FirstName">{props.data.userdata.FirstName}</div>
          //     <div className="LNlabel">Last Name</div>
          //     <div className="LastName">{props.data.userdata.LastName}</div>
          //     <div className="AgeLabel">Age :</div>
          //     <div className="Age">{props.data.userdata.Age}</div>
          //
          //
          // </div>


          <div className={'s'}>
              <br/>
              <h4 style={{textAlign: "center", fontFamily: 'Verdana'}}>Patient Details - {this.props.data.visitname}</h4>
              <br/>
              <Table responsive={true} className='table' bordered={false} size="md" hover={true} striped={false}>
                  {/*<thead >*/}
                  {/*<tr>*/}
                  {/*    <th>First Name</th>*/}
                  {/*    <th>Last Name</th>*/}
                  {/*    <th>Age </th>*/}


                  {/*</tr>*/}
                  {/*</thead>*/}
                  <tbody className={'content'}>
                  <tr>
                      <td width={'auto'}>First Name : {this.props.data.userdata.FirstName}</td>
                      <td width={'auto'}>Last Name : {this.props.data.userdata.LastName}</td>
                      <td width={'auto'}>Age : {this.props.data.userdata.Age}</td>
                  </tr>

                  </tbody>

              </Table>

              <Table responsive={true} className='IndicatorsTable' bordered={false} hover={true} striped={true}  >
                  <thead >
                  <tr>
                      <th>Clinical Indicator</th>
                      <th>Value </th>



                  </tr>
                  </thead>
                  <tbody className={'content'}>
                  {Object.keys(this.props.data.clinicaldata).map((key,index)=>(
                      <tr key={index}>
                          <td>{indicators[index]}</td>
                          <td>{this.props.data.clinicaldata[key]}</td>

                      </tr>
                  ))
                  }

                  </tbody>

              </Table>

          </div>
      )
  }
}
export default ViewPatient